import { Timestamp } from "firebase/firestore";
import { BillingDetails } from "./billing.tsx";
import { Card, CardPreset, GeneratedFrom } from "./card.tsx";
import { Network } from "./network.tsx";
import { Dob } from "./customer.tsx";

export class PaymentMethod {
    private id: string;
    private object: string;
    private acss_debit: AcssDebit | null | undefined;
    private affirm: any | null | undefined;
    private afterpay_clearpay: any | null | undefined;
    private alipay: any | null | undefined;
    private allow_redisplay: string | null | undefined;
    private alma: any | null | undefined;
    private amazon_pay: any | null | undefined;
    private au_becs_debit: AuBecsDebit | null | undefined;
    private bacs_debit: BacsDebit | null | undefined;
    private bancontact: any | null | undefined;
    private billie: any | null | undefined;
    private billing_details: BillingDetails | null | undefined;
    private blik: any | null | undefined;
    private boleto: Boleto | null | undefined;
    private card: Card | null | undefined;
    private card_preset: CardPreset | null | undefined;
    private cash_app: CashApp | null | undefined;
    private created: Timestamp;
    private crypto: any | null | undefined;
    private customer: string | null | undefined;
    private customer_balance: any | null | undefined;
    private eps: Eps | null | undefined;
    private fxp: Eps | null | undefined;
    private giropay: any | null | undefined;
    private grabpay: any | null | undefined;
    private ideal: Ideal | null | undefined;
    private interac_present: InteracPresent | null | undefined;
    private kakao_pay: any | null | undefined;
    private klarna: Klarna | null | undefined;
    private konbini: any | null | undefined;
    private kr_card: KrCard | null | undefined;
    private link: Link | null | undefined;
    private livemode: boolean;
    private metadata: any | null | undefined;
    private mobilepay: any | null | undefined;
    private multibanco: any | null | undefined;
    private never_pay: NeverPay | null | undefined;
    private nz_bank_account: NsBankAccount | null | undefined;
    private oxxo: any | null | undefined;
    private p24: P24 | null | undefined;
    private pay_by_bank: any | null | undefined;
    private payco: any | null | undefined;
    private paynow: any | null | undefined;
    private paypal: PayPal | null | undefined;
    private pix: any | null | undefined;
    private promptpay: any | null | undefined;
    private radar_options: RadarOptions | null | undefined;
    private revolut_pay: any | null | undefined;
    private samsung_pay: any | null | undefined;
    private satispay: any | null | undefined;
    private sepa_debit: SepaDebit | null | undefined;
    private sofort: Sofort | null | undefined;
    private swish: any | null | undefined;
    private twint: any | null | undefined;
    private type: string | null | undefined;
    private us_bank_account: UsBankAccount | null | undefined;
    private wechat_pay: any | null | undefined;
    private zip: any | null | undefined;

    constructor(id: string, object: string, acss_debit: AcssDebit | null | undefined, affirm: any | null | undefined, afterpay_clearpay: any | null | undefined, alipay: any | null | undefined, allow_redisplay: string | null | undefined, alma: any | null | undefined, amazon_pay: any | null | undefined, au_becs_debit: AuBecsDebit | null | undefined, bacs_debit: BacsDebit | null | undefined, bancontact: any | null | undefined, billie: any | null | undefined, billing_details: BillingDetails | null | undefined, blik: any | null | undefined, boleto: Boleto | null | undefined, card: Card | null | undefined, card_preset: CardPreset | null | undefined, cash_app: CashApp | null | undefined, created: Timestamp, crypto: any | null | undefined, customer: string | null | undefined, customer_balance: any | null | undefined, eps: Eps | null | undefined, fxp: Eps | null | undefined, giropay: any | null | undefined, grabpay: any | null | undefined, ideal: Ideal | null | undefined, interac_present: InteracPresent | null | undefined, kakao_pay: any | null | undefined, klarna: Klarna | null | undefined, konbini: any | null | undefined, kr_card: KrCard | null | undefined, link: Link | null | undefined, livemode: boolean, metadata: any | null | undefined, mobilepay: any | null | undefined, multibanco: any | null | undefined, never_pay: NeverPay | null | undefined, nz_bank_account: NsBankAccount | null | undefined, oxxo: any | null | undefined, p24: P24 | null | undefined, pay_by_bank: any | null | undefined, payco: any | null | undefined, paynow: any | null | undefined, paypal: PayPal | null | undefined, pix: any | null | undefined, promptpay: any | null | undefined, radar_options: RadarOptions | null | undefined, revolut_pay: any | null | undefined, samsung_pay: any | null | undefined, satispay: any | null | undefined, sepa_debit: SepaDebit | null | undefined, sofort: Sofort | null | undefined, swish: any | null | undefined, twint: any | null | undefined, type: string | null | undefined, us_bank_account: UsBankAccount | null | undefined, wechat_pay: any | null | undefined, zip: any | null | undefined) {
        this.setId(id);
        this.setObject(object);
        this.setAcssDebit(acss_debit);
        this.setAffirm(affirm);
        this.setAfterpayClearpay(afterpay_clearpay);
        this.setAlipay(alipay);
        this.setAllowRedirect(allow_redisplay);
        this.setAlma(alma);
        this.setAmazonPay(amazon_pay);
        this.setAuBecsDebit(au_becs_debit);
        this.setBacsDebit(bacs_debit);
        this.setBancontact(bancontact);
        this.setBilie(billie);
        this.setBillingDetails(billing_details);
        this.setBlik(blik);
        this.setBoleto(boleto);
        this.setCard(card);
        this.setCardPreset(card_preset);
        this.setCashApp(cash_app);
        this.setCreated(created);
        this.setCrypto(crypto);
        this.setCustomer(customer);
        this.setCustomerBalance(customer_balance);
        this.setEps(eps);
        this.setFxp(fxp);
        this.setGiropay(giropay);
        this.setGrabpay(grabpay);
        this.setIdeal(ideal);
        this.setInteracPresent(interac_present);
        this.setKakaoPay(kakao_pay);
        this.setKlarna(klarna);
        this.setKonbini(konbini);
        this.setKrCard(kr_card);
        this.setLink(link);
        this.setLivemode(livemode);
        this.setMetadata(metadata);
        this.setMobilepay(mobilepay);
        this.setMultibanco(multibanco);
        this.setNeverPay(never_pay);
        this.setNzBankAccount(nz_bank_account);
        this.setOxxo(oxxo);
        this.setP24(p24);
        this.setPayByBank(pay_by_bank);
        this.setPayco(payco);
        this.setPayNow(paynow);
        this.setPaypal(paypal);
        this.setPix(pix);
        this.setPromptpay(promptpay);
        this.setRadarOptions(radar_options);
        this.setRevolutPay(revolut_pay);
        this.setSamsungPay(samsung_pay);
        this.setSatispay(satispay);
        this.setSepaDebit(sepa_debit);
        this.setSofort(sofort);
        this.setSwish(swish);
        this.setTwint(twint);
        this.setType(type);
        this.setUsBankAccount(us_bank_account);
        this.setWechatPay(wechat_pay);
        this.setZip(zip);
    }

    static fromJson(json:any) {
        return new PaymentMethod(json.id, json.object, json.acss_debit !== null && json.acss_debit !== undefined ? AcssDebit.fromJson(json.acss_debit) : null, json.affirm, json.afterpay_clearpay, json.alipay, json.allow_redisplay, json.alma, json.amazon_pay, json.au_becs_debit !== null && json.au_becs_debit !== undefined ? AuBecsDebit.fromJson(json.au_becs_debit) : null, json.bacs_debit !== null && json.bacs_debit !== undefined ? BacsDebit.fromJson(json.bacs_debit) : null, json.bancontact, json.billie, json.billing_details !== null && json.billing_details !== undefined ? BillingDetails.fromJson(json.billing_details) : null, json.blik, json.boleto !== null && json.boleto !== undefined ? Boleto.fromJson(json.boleto) : null, json.card !== null && json.card !== undefined ? Card.fromJson(json.card) : null, json.card_preset !== null && json.card_preset !== undefined ? CardPreset.fromJson(json.card_preset) : null, json.cash_app !== null && json.cash_app !== undefined ? CashApp.fromJson(json.cash_app) : null, json.created, json.crypto, json.customer, json.customer_balance, json.eps !== null && json.eps !== undefined ? Eps.fromJson(json.eps) : null, json.fxp !== null && json.fxp !== undefined ? Eps.fromJson(json.fxp) : null, json.giropay, json.grabpay, json.ideal !== null && json.ideal !== undefined ? Ideal.fromJson(json.ideal) : null, json.interac_present !== null && json.interac_present !== undefined ? InteracPresent.fromJson(json.interac_present) : null, json.kakao_pay, json.klarna !== null && json.klarna !== undefined ? Klarna.fromJson(json.klarna) : null, json.konbini, json.kr_card !== null && json.kr_card !== undefined ? KrCard.fromJson(json.kr_card) : null, json.link !== null && json.link !== undefined ? Link.fromJson(json.link) : null, json.livemode, json.metadata, json.mobilepay, json.multibanco, json.never_pay !== null && json.never_pay !== undefined ? NeverPay.fromJson(json.never_pay) : null, json.nz_bank_account !== null && json.nz_bank_account !== undefined ? NsBankAccount.fromJson(json.nz_bank_account) : null, json.oxxo, json.p24 !== null && json.p24 !== undefined ? P24.fromJson(json.p24) : null, json.pay_by_bank, json.payco, json.paynow, json.paypal !== null && json.paypal !== undefined ? PayPal.fromJson(json.paypal) : null, json.pix, json.promptpay, json.radar_options !== null && json.radar_options !== undefined ? RadarOptions.fromJson(json.radar_options) : null, json.revolut_pay, json.samsung_pay, json.satispay, json.sepa_debit !== null && json.sepa_debit !== undefined ? SepaDebit.fromJson(json.sepa_debit) : null, json.sofort !== null && json.sofort !== undefined ? Sofort.fromJson(json.sofort) : null, json.swish, json.twint, json.type, json.us_bank_account !== null && json.us_bank_account !== undefined ? UsBankAccount.fromJson(json.us_bank_account) : null, json.wechat_pay, json.zip);
    }

    setId(newId:string) {
        this.id = newId;
    }
    setObject(newObject:string) {
        this.object = newObject;
    }
    setAcssDebit(newAcssDebit:AcssDebit | null | undefined) {
        this.acss_debit = newAcssDebit;
    }
    setAffirm(newAffirm:any | null | undefined) {
        this.affirm = newAffirm;
    }
    setAfterpayClearpay(newAfterpayClearpay:any | null | undefined) {
        this.afterpay_clearpay = newAfterpayClearpay;
    }
    setAlipay(newAlipay:any | null | undefined) {
        this.alipay = newAlipay;
    }
    setAllowRedirect(newAllowRedirect:string | null | undefined) {
        this.allow_redisplay = newAllowRedirect;
    }
    setAlma(newAlma:any | null | undefined) {
        this.alma = newAlma;
    }
    setAmazonPay(newAmazonPay:any | null | undefined) {
        this.amazon_pay = newAmazonPay;
    }
    setAuBecsDebit(newAuBecsDebit:AuBecsDebit | null | undefined) {
        this.au_becs_debit = newAuBecsDebit;
    }
    setBacsDebit(newBacsDebit:BacsDebit | null | undefined) {
        this.bacs_debit = newBacsDebit;
    }
    setBancontact(newBancontact:any | null | undefined) {
        this.bancontact = newBancontact;
    }
    setBilie(newBilie:any | null | undefined) {
        this.billie = newBilie;
    }
    setBillingDetails(newBillingDetails:BillingDetails | null | undefined) {
        this.billing_details = newBillingDetails;
    }
    setBlik(newBlik:any | null | undefined) {
        this.blik = newBlik;
    }
    setBoleto(newBoleto:Boleto | null | undefined) {
        this.boleto = newBoleto;
    }
    setCard(newCard:Card | null | undefined) {
        this.card = newCard;
    }
    setCardPreset(newCardPreset:CardPreset | null | undefined) {
        this.card_preset = newCardPreset;
    }
    setCashApp(newCashApp:CashApp | null | undefined) {
        this.cash_app = newCashApp;
    }
    setCreated(newCreated:Timestamp) {
        this.created = newCreated;
    }
    setCrypto(newCrypto:any | null | undefined) {
        this.crypto = newCrypto;
    }
    setCustomer(newCustomer:string | null | undefined) {
        this.customer = newCustomer;
    }
    setCustomerBalance(newCustomerBalance:any | null | undefined) {
        this.customer_balance = newCustomerBalance;
    }
    setEps(newEps:Eps | null | undefined) {
        this.eps = newEps;
    }
    setFxp(newFxp:Eps | null | undefined) {
        this.fxp = newFxp;
    }
    setGiropay(newGiropay:any | null | undefined) {
        this.giropay = newGiropay;
    }
    setGrabpay(newGrabpay:any | null | undefined) {
        this.grabpay = newGrabpay;
    }
    setIdeal(newIdeal:Ideal | null | undefined) {
        this.ideal = newIdeal;
    }
    setInteracPresent(newInteracPresent:InteracPresent | null | undefined) {
        this.interac_present = newInteracPresent;
    }
    setKakaoPay(newKakaoPay:any | null | undefined) {
        this.kakao_pay = newKakaoPay;
    }
    setKlarna(newKlarna:Klarna | null | undefined) {
        this.klarna = newKlarna;
    }
    setKonbini(newKonbini:any | null | undefined) {
        this.konbini = newKonbini;
    }
    setKrCard(newKrCard:KrCard | null | undefined) {
        this.kr_card = newKrCard;
    }
    setLink(newLink:Link | null | undefined) {
        this.link = newLink;
    }
    setLivemode(newLivemode:boolean) {
        this.livemode = newLivemode;
    }
    setMetadata(newMetadata:any | null | undefined) {
        this.metadata = newMetadata;
    }
    setMobilepay(newMobilepay:any | null | undefined) {
        this.mobilepay = newMobilepay;
    }
    setMultibanco(newMultibanco:any | null | undefined) {
        this.multibanco = newMultibanco;
    }
    setNeverPay(newNeverPay:NeverPay | null | undefined) {
        this.never_pay = newNeverPay;
    }
    setNzBankAccount(newNzBankAccount:NsBankAccount | null | undefined) {
        this.nz_bank_account = newNzBankAccount;
    }
    setOxxo(newOxxo:any | null | undefined) {
        this.oxxo = newOxxo;
    }
    setP24(newP24:P24 | null | undefined) {
        this.p24 = newP24;
    }
    setPayByBank(newPayByBank:any | null | undefined) {
        this.pay_by_bank = newPayByBank;
    }
    setPayco(newPayco:any | null | undefined) {
        this.payco = newPayco;
    }
    setPayNow(newPayNow:any | null | undefined) {
        this.paynow = newPayNow;
    }
    setPaypal(newPaypal:PayPal | null | undefined) {
        this.paypal = newPaypal;
    }
    setPix(newPix:any | null | undefined) {
        this.pix = newPix;
    }
    setPromptpay(newPromptpay:any | null | undefined) {
        this.promptpay = newPromptpay;
    }
    setRadarOptions(newRadarOptions:RadarOptions | null | undefined) {
        this.radar_options = newRadarOptions;
    }
    setRevolutPay(newRevolutPay:any | null | undefined) {
        this.revolut_pay = newRevolutPay;
    }
    setSamsungPay(newSamsungPay:any | null | undefined) {
        this.samsung_pay = newSamsungPay;
    }
    setSatispay(newSatispay:any | null | undefined) {
        this.satispay = newSatispay;
    }
    setSepaDebit(newSepaDebit:SepaDebit | null | undefined) {
        this.sepa_debit = newSepaDebit;
    }
    setSofort(newSofort:Sofort | null | undefined) {
        this.sofort = newSofort;
    }
    setSwish(newSwish:any | null | undefined) {
        this.swish = newSwish;
    }
    setTwint(newTwint:any | null | undefined) {
        this.twint = newTwint;
    }
    setType(newType:string | null | undefined) {
        this.type = newType;
    }
    setUsBankAccount(newUsBankAccount:UsBankAccount | null | undefined) {
        this.us_bank_account = newUsBankAccount;
    }
    setWechatPay(newWechatPay:any | null | undefined) {
        this.wechat_pay = newWechatPay;
    }
    setZip(newZip:any | null | undefined) {
        this.zip = newZip;
    }

    getId() {
        return this.id;
    }
    getObject() {
        return this.object;
    }
    getAcssDebit() {
        return this.acss_debit;
    }
    getAffirm() {
        return this.affirm;
    }
    getAfterpayClearpay() {
        return this.afterpay_clearpay;
    }
    getAlipay() {
        return this.alipay;
    }
    getAllowRedirect() {
        return this.allow_redisplay;
    }
    getAlma() {
        return this.alma;
    }
    getAmazonPay() {
        return this.amazon_pay;
    }
    getAuBecsDebit() {
        return this.au_becs_debit;
    }
    getBacsDebit() {
        return this.bacs_debit;
    }
    getBancontact() {
        return this.bancontact;
    }
    getBilie() {
        return this.billie;
    }
    getBillingDetails() {
        return this.billing_details;
    }
    getBlik() {
        return this.blik;
    }
    getBoleto() {
        return this.boleto;
    }
    getCard() {
        return this.card;
    }
    getCardPreset() {
        return this.card_preset;
    }
    getCashApp() {
        return this.cash_app;
    }
    getCreated() {
        return this.created;
    }
    getCrypto() {
        return this.crypto;
    }
    getCustomer() {
        return this.customer;
    }
    getCustomerBalance() {
        return this.customer_balance;
    }
    getEps() {
        return this.eps;
    }
    getFxp() {
        return this.fxp;
    }
    getGiropay() {
        return this.giropay;
    }
    getGrabpay() {
        return this.grabpay;
    }
    getIdeal() {
        return this.ideal;
    }
    getInteracPresent() {
        return this.interac_present;
    }
    getKakaoPay() {
        return this.kakao_pay;
    }
    getKlarna() {
        return this.klarna;
    }
    getKonbini() {
        return this.konbini;
    }
    getKrCard() {
        return this.kr_card;
    }
    getLink() {
        return this.link;
    }
    getLivemode() {
        return this.livemode;
    }
    getMetadata() {
        return this.metadata;
    }
    getMobilepay() {
        return this.mobilepay;
    }
    getMultibanco() {
        return this.multibanco;
    }
    getNeverPay() {
        return this.never_pay;
    }
    getNzBankAccount() {
        return this.nz_bank_account;
    }
    getOxxo() {
        return this.oxxo;
    }
    getP24() {
        return this.p24;
    }
    getPayByBank() {
        return this.pay_by_bank;
    }
    getPayco() {
        return this.payco;
    }
    getPayNow() {
        return this.paynow;
    }
    getPaypal() {
        return this.paypal;
    }
    getPix() {
        return this.pix;
    }
    getPromptpay() {
        return this.promptpay;
    }
    getRadarOptions() {
        return this.radar_options;
    }
    getRevolutPay() {
        return this.revolut_pay;
    }
    getSamsungPay() {
        return this.samsung_pay;
    }
    getSatispay() {
        return this.satispay;
    }
    getSepaDebit() {
        return this.sepa_debit;
    }
    getSofort() {
        return this.sofort;
    }
    getSwish() {
        return this.swish;
    }
    getTwint() {
        return this.twint;
    }
    getType() {
        return this.type;
    }
    getUsBankAccount() {
        return this.us_bank_account;
    }
    getWechatPay() {
        return this.wechat_pay;
    }
    getZip() {
        return this.zip;
    }
}

export class AcssDebit {
    private bank_name: string | null | undefined;
    private fingerprint: string | null | undefined;
    private institution_number: string | null | undefined;
    private last4: string | null | undefined;
    private transit_number: string | null | undefined;

    constructor(bank_name: string | null | undefined, fingerprint: string | null | undefined, institution_number: string | null | undefined, last4: string | null | undefined, transit_number: string | null | undefined) {
        this.setBankName(bank_name);
        this.setFingerprint(fingerprint);
        this.setInstitutionNumber(institution_number);
        this.setLast4(last4);
        this.setTransitNumber(transit_number);
    }

    static fromJson(json:any) {
        console.log(json);
        return new AcssDebit(json.bank_name, json.fingerprint, json.institution_number, json.last4, json.transit_number);
    }

    setBankName(newBankName:string | null | undefined) {
        this.bank_name = newBankName;
    }
    setFingerprint(newFingerprint:string | null | undefined) {
        this.fingerprint = newFingerprint;
    }
    setInstitutionNumber(newInstitutionNumber:string | null | undefined) {
        this.institution_number = newInstitutionNumber;
    }
    setLast4(newLast4:string | null | undefined) {
        this.last4 = newLast4;
    }
    setTransitNumber(newTransitNumber:string | null | undefined) {
        this.transit_number = newTransitNumber;
    }

    getBankName() {
        return this.bank_name;
    }
    getFingerprint() {
        return this.fingerprint;
    }
    getInstitutionNumber() {
        return this.institution_number;
    }
    getLast4() {
        return this.last4;
    }
    getTransitNumber() {
        return this.transit_number;
    }
}

export class AuBecsDebit {
    private bsb_number: string | null | undefined;
    private fingerprint: string | null | undefined;
    private last4: string | null | undefined;

    constructor(bsb_number: string | null | undefined, fingerprint: string | null | undefined, last4: string | null | undefined) {
        this.setBsbNumber(bsb_number);
        this.setFingerprint(fingerprint);
        this.setLast4(last4);
    }

    static fromJson(json:any) {
        return new AuBecsDebit(json.bsb_number, json.fingerprint, json.last4);
    }

    setBsbNumber(newBsbNumber:string | null | undefined) {
        this.bsb_number = newBsbNumber;
    }
    setFingerprint(newFingerprint:string | null | undefined) {
        this.fingerprint = newFingerprint;
    }
    setLast4(newLast4:string | null | undefined) {
        this.last4 = newLast4;
    }

    getBsbNumber() {
        return this.bsb_number;
    }
    getFingerprint() {
        return this.fingerprint;
    }
    getLast4() {
        return this.last4;
    }
}

export class BacsDebit {
    private fingerprint: string | null | undefined;
    private last4: string | null | undefined;
    private sort_code: string | null | undefined;

    constructor(fingerprint: string | null | undefined, last4: string | null | undefined, sort_code: string | null | undefined) {
        this.setFingerprint(fingerprint);
        this.setLast4(last4);
        this.setSortCode(sort_code);
    }

    static fromJson(json:any) {
        return new BacsDebit(json.fingerprint, json.last4, json.sort_code);
    }

    setFingerprint(newFingerprint:string | null | undefined) {
        this.fingerprint = newFingerprint;
    }
    setLast4(newLast4:string | null | undefined) {
        this.last4 = newLast4;
    }
    setSortCode(newSortCode:string | null | undefined) {
        this.sort_code = newSortCode;
    }

    getFingerprint() {
        return this.fingerprint;
    }
    getLast4() {
        return this.last4;
    }
    getSortCode() {
        return this.sort_code;
    }
}

export class Boleto {
    private tax_id: string;

    constructor(tax_id: string) {
        this.setTaxId(tax_id);
    }

    static fromJson(json:any) {
        return new Boleto(json.tax_id);
    }

    setTaxId(newTaxId:string) {
        this.tax_id = newTaxId;
    }

    getTaxId() {
        return this.tax_id;
    }
}

export class PaymentMethodDetails {
    private card_preset: CardPreset | null | undefined;
    private type: string;

    constructor(card_preset: CardPreset | null | undefined, type: string) {
        this.setCardPreset(card_preset);
        this.setType(type);
    }

    static fromJson(json:any) {
        return new PaymentMethodDetails(json.card_preset !== null && json.card_preset !== undefined ? CardPreset.fromJson(json.card_preset) : null, json.type);
    }

    setCardPreset(newCardPreset:CardPreset | null | undefined) {
        this.card_preset = newCardPreset;
    }
    setType(newType:string) {
        this.type = newType;
    }

    getCardPreset() {
        return this.card_preset;
    }
    getType() {
        return this.type;
    }
}

export class Offline {
    private stored_at: Timestamp | null | undefined;
    private type: string | null | undefined;

    constructor(stored_at: Timestamp | null | undefined, type: string | null | undefined) {
        this.setStoredAt(stored_at);
        this.setType(type);
    }

    static fromJson(json:any) {
        return new Offline(json.stored_at !== null && json.stored_at !== undefined ? new Timestamp(json.stored_at, 0) : null, json.type);
    }

    setStoredAt(newStoredAt:Timestamp | null | undefined) {
        this.stored_at = newStoredAt;
    }
    setType(newType:string | null | undefined) {
        this.type = newType;
    }

    getStoredAt() {
        return this.stored_at;
    }
    getType() {
        return this.type;
    }
}

export class CashApp {
    buyer_id: string | null | undefined;
    cashtag: string | null | undefined;

    constructor(buyer_id: string | null | undefined, cashtag: string | null | undefined) {
        this.setBuyerId(buyer_id);
        this.setCashtag(cashtag);
    }

    static fromJson(json:any) {
        return new CashApp(json.buyer_id, json.cashtag);
    }

    setBuyerId(newBuyerId:string | null | undefined) {
        this.buyer_id = newBuyerId;
    }
    setCashtag(newCashtag:string | null | undefined) {
        this.cashtag = newCashtag;
    }

    getBuyerId() {
        return this.buyer_id;
    }
    getCashtag() {
        return this.cashtag;
    }
}

export class Eps {
    private bank: string | null | undefined;
    private fpx: Fpx | null | undefined;
    private giropay: any | null | undefined;
    private grabpay: any | null | undefined;
    private ideal: Ideal | null | undefined;
    private interac_present: InteracPresent | null | undefined;
    private kakao_pay: any | null | undefined;
    private klarna: Klarna | null | undefined;
    private konbini: any | null | undefined;
    private kr_card: KrCard | null | undefined;
    private link: Link | null | undefined;
    private livemode: boolean;
    private metadata: any | null | undefined;
    private mobilepay: any | null | undefined;
    private multibanco: any | null | undefined;
    private never_pay: NeverPay | null | undefined;
    private nz_bank_account: NsBankAccount | null | undefined;
    private oxxo: any | null | undefined;
    private p24: any | null | undefined;
    private pay_by_bank: any | null | undefined;
    private payco: any | null | undefined;
    private paynow: any | null | undefined;
    private paypal: PayPal | null | undefined;
    private pix: any | null | undefined;
    private promptpay: any | null | undefined;
    private radar_options: RadarOptions | null | undefined;
    private revolut_pay: any | null | undefined;
    private samsung_pay: any | null | undefined;
    private satispay: any | null | undefined;
    private sepa_debit: SepaDebit | null | undefined;
    private sofort: Sofort | null | undefined;
    private swish: any | null | undefined;
    private twint: any | null | undefined;
    private type: string;
    private us_bank_account: UsBankAccount | null | undefined;
    private wechat_pay: any | null | undefined;
    private zip: any | null | undefined;

    constructor(bank: string | null | undefined, fpx: Fpx | null | undefined, giropay: any | null | undefined, grabpay: any | null | undefined, ideal: Ideal | null | undefined, interac_present: InteracPresent | null | undefined, kakao_pay: any | null | undefined, klarna: Klarna | null | undefined, konbini: any | null | undefined, kr_card: KrCard | null | undefined, link: Link | null | undefined, livemode: boolean, metadata: any | null | undefined, mobilepay: any | null | undefined, multibanco: any | null | undefined, never_pay: NeverPay | null | undefined, nz_bank_account: NsBankAccount | null | undefined, oxxo: any | null | undefined, p24: any | null | undefined, pay_by_bank: any | null | undefined, payco: any | null | undefined, paynow: any | null | undefined, paypal: PayPal | null | undefined, pix: any | null | undefined, promptpay: any | null | undefined, radar_options: RadarOptions | null | undefined, revolut_pay: any | null | undefined, samsung_pay: any | null | undefined, satispay: any | null | undefined, sepa_debit: SepaDebit | null | undefined, sofort: Sofort | null | undefined, swish: any | null | undefined, twint: any | null | undefined, type: string, us_bank_account: UsBankAccount | null | undefined, wechat_pay: any | null | undefined, zip: any | null | undefined) {
        this.setBank(bank);
        this.setFpx(fpx);
        this.setGiropay(giropay);
        this.setGrabpay(grabpay);
        this.setIdeal(ideal);
        this.setInteracPresent(interac_present);
        this.setKakaoPay(kakao_pay);
        this.setKlarna(klarna);
        this.setKonbini(konbini);
        this.setKrCard(kr_card);
        this.setLink(link);
        this.setLivemode(livemode);
        this.setMetadata(metadata);
        this.setMobilepay(mobilepay);
        this.setMultibanco(multibanco);
        this.setNeverPay(never_pay);
        this.setNzBankAccount(nz_bank_account);
        this.setOxxo(oxxo);
        this.setP24(p24);
        this.setPayByBank(pay_by_bank);
        this.setPayco(payco);
        this.setPayNow(paynow);
        this.setPaypal(paypal);
        this.setPix(pix);
        this.setPromptpay(promptpay);
        this.setRadarOptions(radar_options);
        this.setRevolutPay(revolut_pay);
        this.setSamsungPay(samsung_pay);
        this.setSatispay(satispay);
        this.setSepaDebit(sepa_debit);
        this.setSofort(sofort);
        this.setSwish(swish);
        this.setTwint(twint);
        this.setType(type);
        this.setUsBankAccount(us_bank_account);
        this.setWechatPay(wechat_pay);
        this.setZip(zip);
    }

    static fromJson(json:any) {
        return new Eps(json.bank, json.fpx !== null && json.fpx !== undefined ? Fpx.fromJson(json.fpx) : null, json.giropay, json.grabpay, json.ideal !== null && json.ideal !== undefined ? Ideal.fromJson(json.ideal) : null, json.interac_present !== null && json.interac_present !== undefined ? InteracPresent.fromJson(json.interac_present) : null, json.kakao_pay, json.klarna !== null && json.klarna !== undefined ? Klarna.fromJson(json.klarna) : null, json.konbini, json.kr_card !== null && json.kr_card !== undefined ? KrCard.fromJson(json.kr_card) : null, json.link !== null && json.link !== undefined ? Link.fromJson(json.link) : null, json.livemode, json.metadata, json.mobilepay, json.multibanco, json.never_pay !== null && json.never_pay !== undefined ? NeverPay.fromJson(json.never_pay) : null, json.nz_bank_account !== null && json.nz_bank_account !== undefined ? NsBankAccount.fromJson(json.nz_bank_account) : null, json.oxxo, json.p24, json.pay_by_bank, json.payco, json.paynow, json.paypal !== null && json.paypal !== undefined ? PayPal.fromJson(json.paypal) : null, json.pix, json.promptpay, json.radar_options !== null && json.radar_options !== undefined ? RadarOptions.fromJson(json.radar_options) : null, json.revolut_pay, json.samsung_pay, json.satispay, json.sepa_debit !== null && json.sepa_debit !== undefined ? SepaDebit.fromJson(json.sepa_debit) : null, json.sofort !== null && json.sofort !== undefined ? Sofort.fromJson(json.sofort) : null, json.swish, json.twint, json.type, json.us_bank_account !== null && json.us_bank_account !== undefined ? UsBankAccount.fromJson(json.us_bank_account) : null, json.wechat_pay, json.zip);
    }

    setBank(newBank:string | null | undefined) {
        this.bank = newBank;
    }
    setFpx(newFpx:Fpx | null | undefined) {
        this.fpx = newFpx;
    }
    setGiropay(newGiropay:any | null | undefined) {
        this.giropay = newGiropay;
    }
    setGrabpay(newGrabpay:any | null | undefined) {
        this.grabpay = newGrabpay;
    }
    setIdeal(newIdeal:Ideal | null | undefined) {
        this.ideal = newIdeal;
    }
    setInteracPresent(newInteracPresent:InteracPresent | null | undefined) {
        this.interac_present = newInteracPresent;
    }
    setKakaoPay(newKakaoPay:any | null | undefined) {
        this.kakao_pay = newKakaoPay;
    }
    setKlarna(newKlarna:Klarna | null | undefined) {
        this.klarna = newKlarna;
    }
    setKonbini(newKonbini:any | null | undefined) {
        this.konbini = newKonbini;
    }
    setKrCard(newKrCard:KrCard | null | undefined) {
        this.kr_card = newKrCard;
    }
    setLink(newLink:Link | null | undefined) {
        this.link = newLink;
    }
    setLivemode(newLivemode:boolean) {
        this.livemode = newLivemode;
    }
    setMetadata(newMetadata:any | null | undefined) {
        this.metadata = newMetadata;
    }
    setMobilepay(newMobilepay:any | null | undefined) {
        this.mobilepay = newMobilepay;
    }
    setMultibanco(newMultibanco:any | null | undefined) {
        this.multibanco = newMultibanco;
    }
    setNeverPay(newNeverPay:NeverPay | null | undefined) {
        this.never_pay = newNeverPay;
    }
    setNzBankAccount(newNzBankAccount:NsBankAccount | null | undefined) {
        this.nz_bank_account = newNzBankAccount;
    }
    setOxxo(newOxxo:any | null | undefined) {
        this.oxxo = newOxxo;
    }
    setP24(newP24:any | null | undefined) {
        this.p24 = newP24;
    }
    setPayByBank(newPayByBank:any | null | undefined) {
        this.pay_by_bank = newPayByBank;
    }
    setPayco(newPayco:any | null | undefined) {
        this.payco = newPayco;
    }
    setPayNow(newPayNow:any | null | undefined) {
        this.paynow = newPayNow;
    }
    setPaypal(newPaypal:PayPal | null | undefined) {
        this.paypal = newPaypal;
    }
    setPix(newPix:any | null | undefined) {
        this.pix = newPix;
    }
    setPromptpay(newPromptpay:any | null | undefined) {
        this.promptpay = newPromptpay;
    }
    setRadarOptions(newRadarOptions:RadarOptions | null | undefined) {
        this.radar_options = newRadarOptions;
    }
    setRevolutPay(newRevolutPay:any | null | undefined) {
        this.revolut_pay = newRevolutPay;
    }
    setSamsungPay(newSamsungPay:any | null | undefined) {
        this.samsung_pay = newSamsungPay;
    }
    setSatispay(newSatispay:any | null | undefined) {
        this.satispay = newSatispay;
    }
    setSepaDebit(newSepaDebit:SepaDebit | null | undefined) {
        this.sepa_debit = newSepaDebit;
    }
    setSofort(newSofort:Sofort | null | undefined) {
        this.sofort = newSofort;
    }
    setSwish(newSwish:any | null | undefined) {
        this.swish = newSwish;
    }
    setTwint(newTwint:any | null | undefined) {
        this.twint = newTwint;
    }
    setType(newType:string) {
        this.type = newType;
    }
    setUsBankAccount(newUsBankAccount:UsBankAccount | null | undefined) {
        this.us_bank_account = newUsBankAccount;
    }
    setWechatPay(newWechatPay:any | null | undefined) {
        this.wechat_pay = newWechatPay;
    }
    setZip(newZip:any | null | undefined) {
        this.zip = newZip;
    }

    getBank() {
        return this.bank;
    }
    getFpx() {
        return this.fpx;
    }
    getGiropay() {
        return this.giropay;
    }
    getGrabpay() {
        return this.grabpay;
    }
    getIdeal() {
        return this.ideal;
    }
    getInteracPresent() {
        return this.interac_present;
    }
    getKakaoPay() {
        return this.kakao_pay;
    }
    getKlarna() {
        return this.klarna;
    }
    getKonbini() {
        return this.konbini;
    }
    getKrCard() {
        return this.kr_card;
    }
    getLink() {
        return this.link;
    }
    getLivemode() {
        return this.livemode;
    }
    getMetadata() {
        return this.metadata;
    }
    getMobilepay() {
        return this.mobilepay;
    }
    getMultibanco() {
        return this.multibanco;
    }
    getNeverPay() {
        return this.never_pay;
    }
    getNzBankAccount() {
        return this.nz_bank_account;
    }
    getOxxo() {
        return this.oxxo;
    }
    getP24() {
        return this.p24;
    }
    getPayByBank() {
        return this.pay_by_bank;
    }
    getPayco() {
        return this.payco;
    }
    getPayNow() {
        return this.paynow;
    }
    getPaypal() {
        return this.paypal;
    }
    getPix() {
        return this.pix;
    }
    getPromptpay() {
        return this.promptpay;
    }
    getRadarOptions() {
        return this.radar_options;
    }
    getRevolutPay() {
        return this.revolut_pay;
    }
    getSamsungPay() {
        return this.samsung_pay;
    }
    getSatispay() {
        return this.satispay;
    }
    getSepaDebit() {
        return this.sepa_debit;
    }
    getSofort() {
        return this.sofort;
    }
    getSwish() {
        return this.swish;
    }
    getTwint() {
        return this.twint;
    }
    getType() {
        return this.type;
    }
    getUsBankAccount() {
        return this.us_bank_account;
    }
    getWechatPay() {
        return this.wechat_pay;
    }
    getZip() {
        return this.zip;
    }
}

export class Fpx {
    private bank: string | null | undefined;
    
    constructor(bank: string | null | undefined) {
        this.setBank(bank);
    }

    static fromJson(json:any) {
        return new Fpx(json.bank);
    }

    setBank(newBank:string | null | undefined) {
        this.bank = newBank;
    }

    getBank() {
        return this.bank;
    }
}

export class Ideal {
    private bank: string | null | undefined;
    private bic: string | null | undefined;

    constructor(bank: string | null | undefined, bic: string | null | undefined) {
        this.setBank(bank);
        this.setBic(bic);
    }

    static fromJson(json:any) {
        return new Ideal(json.bank, json.bic);
    }

    setBank(newBank:string | null | undefined) {
        this.bank = newBank;
    }
    setBic(newBic:string | null | undefined) {
        this.bic = newBic;
    }

    getBank() {
        return this.bank;
    }
    getBic() {
        return this.bic;
    }
}

export class InteracPresent {
    private brand: string | null | undefined;
    private cardholder_name: string | null | undefined;
    private country: string | null | undefined;
    private description: string | null | undefined;
    private exp_month: number;
    private exp_year: number;
    private fingerprint: string | null | undefined;
    private funding: string | null | undefined;
    private issuer: string | null | undefined;
    private last4: string | null | undefined;
    private networks: Network | null | undefined;
    private preferred_locales: string[] | null | undefined;
    private read_method: string | null | undefined;

    constructor(brand: string | null | undefined, cardholder_name: string | null | undefined, country: string | null | undefined, description: string | null | undefined, exp_month: number, exp_year: number, fingerprint: string | null | undefined, funding: string | null | undefined, issuer: string | null | undefined, last4: string | null | undefined, networks: Network | null | undefined, preferred_locales: string[] | null | undefined, read_method: string | null | undefined) {
        this.setBrand(brand);
        this.setCardholderName(cardholder_name);
        this.setCountry(country);
        this.setDescription(description);
        this.setExpMonth(exp_month);
        this.setExpYear(exp_year);
        this.setFingerprint(fingerprint);
        this.setFunding(funding);
        this.setIssuer(issuer);
        this.setLast4(last4);
        this.setNetworks(networks);
        this.setPreferredLocales(preferred_locales);
        this.setReadMethod(read_method);
    }

    static fromJson(json:any) {
        return new InteracPresent(json.brand, json.cardholder_name, json.country, json.description, json.exp_month, json.exp_year, json.fingerprint, json.funding, json.issuer, json.last4, json.network !== null && json.network !== undefined ? Network.fromJson(json.network) : null, json.preferred_locales, json.read_method);
    }

    setBrand(newBrand:string | null | undefined) {
        this.brand = newBrand;
    }
    setCardholderName(newCardholderName:string | null | undefined) {
        this.cardholder_name = newCardholderName;
    }
    setCountry(newCountry:string | null | undefined) {
        this.country = newCountry;
    }
    setDescription(newDescription:string | null | undefined) {
        this.description = newDescription;
    }
    setExpMonth(newExpMonth:number) {
        this.exp_month = newExpMonth;
    }
    setExpYear(newExpYear:number) {
        this.exp_year = newExpYear;
    }
    setFingerprint(newFingerprint:string | null | undefined) {
        this.fingerprint = newFingerprint;
    }
    setFunding(newFunding:string | null | undefined) {
        this.funding = newFunding;
    }
    setIssuer(newIssuer:string | null | undefined) {
        this.issuer = newIssuer;
    }
    setLast4(newLast4:string | null | undefined) {
        this.last4 = newLast4;
    }
    setNetworks(newNetworks:Network | null | undefined) {
        this.networks = newNetworks;
    }
    setPreferredLocales(newPreferredLocales:string[] | null | undefined) {
        this.preferred_locales = newPreferredLocales;
    }
    setReadMethod(newReadMethod:string | null | undefined) {
        this.read_method = newReadMethod;
    }

    getBrand() {
        return this.brand;
    }
    getCardholderName() {
        return this.cardholder_name;
    }
    getCountry() {
        return this.country;
    }
    getDescription() {
        return this.description;
    }
    getExpMonth() {
        return this.exp_month;
    }
    getExpYear() {
        return this.exp_year;
    }
    getFingerprint() {
        return this.fingerprint;
    }
    getFunding() {
        return this.funding;
    }
    getIssuer() {
        return this.issuer;
    }
    getLast4() {
        return this.last4;
    }
    getNetworks() {
        return this.networks;
    }
    getPreferredLocales() {
        return this.preferred_locales;
    }
    getReadMethod() {
        return this.read_method;
    }
}

export class Klarna {
    private dob: Dob | null | undefined;

    constructor(dob: Dob | null | undefined) {
        this.setDob(dob);
    }

    static fromJson(json:any) {
        return new Klarna(json.dob !== null && json.dob !== undefined ? Dob.fromJson(json.dob) : null);
    }

    setDob(newDob:Dob | null | undefined) {
        this.dob = newDob;
    }

    getDob() {
        return this.dob;
    }
}

export class KrCard {
    private brand: string | null | undefined;
    private last4: string | null | undefined;

    constructor(brand: string | null | undefined, last4: string | null | undefined) {
        this.setBrand(brand);
        this.setLast4(last4);
    }

    static fromJson(json:any) {
        return new KrCard(json.brand, json.last4);
    }

    setBrand(newBrand:string | null | undefined) {
        this.brand = newBrand;
    }
    setLast4(newLast4:string | null | undefined) {
        this.last4 = newLast4;
    }

    getBrand() {
        return this.brand;
    }
    getLast4() {
        return this.last4;
    }
}

export class Link {
    private email: string | null | undefined;

    constructor(email: string | null | undefined) {
        this.setEmail(email);
    }

    static fromJson(json:any) {
        return new Link(json.email);
    }

    setEmail(newEmail:string | null | undefined) {
        this.email = newEmail;
    }

    getEmail() {
        return this.email;
    }
}

export class NeverPay {
    private buyer_id: string | null | undefined;
    private funding: string | null | undefined;

    constructor(buyer_id: string | null | undefined, funding: string | null | undefined) {
        this.setBuyerId(buyer_id);
        this.setFunding(funding);
    }

    static fromJson(json:any) {
        return new NeverPay(json.buyer_id, json.funding);
    }

    setBuyerId(newBuyerId:string | null | undefined) {
        this.buyer_id = newBuyerId;
    }
    setFunding(newFunding:string | null | undefined) {
        this.funding = newFunding;
    }

    getBuyerId() {
        return this.buyer_id;
    }
    getFunding() {
        return this.funding;
    }
}

export class NsBankAccount {
    private account_holder_name: string | null | undefined;
    private bank_code: string;
    private bank_name: string;
    private branch_code: string;
    private last4: string;
    private suffix: string | null | undefined;

    constructor(account_holder_name: string | null | undefined, bank_code: string, bank_name: string, branch_code: string, last4: string, suffix: string | null | undefined) {
        this.setAccountHolderName(account_holder_name);
        this.setBankCode(bank_code);
        this.setBankName(bank_name);
        this.setBranchCode(branch_code);
        this.setLast4(last4);
        this.setSuffix(suffix);
    }

    static fromJson(json:any) {
        return new NsBankAccount(json.account_holder_name, json.bank_code, json.bank_name, json.branch_code, json.last4, json.suffix);
    }

    setAccountHolderName(newAccountHolderName:string | null | undefined) {
        this.account_holder_name = newAccountHolderName;
    }
    setBankCode(newBankCode:string) {
        this.bank_code = newBankCode;
    }
    setBankName(newBankName:string) {
        this.bank_name = newBankName;
    }
    setBranchCode(newBranchCode:string) {
        this.branch_code = newBranchCode;
    }
    setLast4(newLast4:string) {
        this.last4 = newLast4;
    }
    setSuffix(newSuffix:string | null | undefined) {
        this.suffix = newSuffix;
    }

    getAccountHolderName() {
        return this.account_holder_name;
    }
    getBankCode() {
        return this.bank_code;
    }
    getBankName() {
        return this.bank_name;
    }
    getBranchCode() {
        return this.branch_code;
    }
    getLast4() {
        return this.last4;
    }
    getSuffix() {
        return this.suffix;
    }
}

export class PayPal {
    private country: string | null | undefined;
    private payer_email: string | null | undefined;
    private payer_id: string | null | undefined;

    constructor(country: string | null | undefined, payer_email: string | null | undefined, payer_id: string | null | undefined) {
        this.setCountry(country);
        this.setPayerEmail(payer_email);
        this.setPayerId(payer_id);
    }

    static fromJson(json:any) {
        return new PayPal(json.country, json.payer_email, json.payer_id);
    }

    setCountry(newCountry:string | null | undefined) {
        this.country = newCountry;
    }
    setPayerEmail(newPayerEmail:string | null | undefined) {
        this.payer_email = newPayerEmail;
    }
    setPayerId(newPayerId:string | null | undefined) {
        this.payer_id = newPayerId;
    }

    getCountry() {
        return this.country;
    }
    getPayerEmail() {
        return this.payer_email;
    }
    getPayerId() {
        return this.payer_id;
    }
}

export class RadarOptions {
    private session: string | null | undefined;

    constructor(session: string | null | undefined) {
        this.setSession(session);
    }

    static fromJson(json:any) {
        return new RadarOptions(json.session);
    }

    setSession(newSession:string | null | undefined) {
        this.session = newSession;
    }

    getSession() {
        return this.session;
    }
}

export class SepaDebit {
    private bank_code: string | null | undefined;
    private branch_code: string | null | undefined;
    private country: string | null | undefined;
    private fingerprint: string | null | undefined;
    private last4: string | null | undefined;
    private generated_from: GeneratedFrom | null | undefined;

    constructor(bank_code: string | null | undefined, branch_code: string | null | undefined, country: string | null | undefined, fingerprint: string | null | undefined, last4: string | null | undefined, generated_from: GeneratedFrom | null | undefined) {
        this.setBankCode(bank_code);
        this.setBranchCode(branch_code);
        this.setCountry(country);
        this.setFingerprint(fingerprint);
        this.setLast4(last4);
        this.setGeneratedFrom(generated_from);
    }

    static fromJson(json:any) {
        return new SepaDebit(json.bank_code, json.branch_code, json.country, json.fingerprint, json.last4, json.generated_from !== null && json.generated_from !== undefined ? GeneratedFrom.fromJson(json.generated_from) : null);
    }

    setBankCode(newBankCode:string | null | undefined) {
        this.bank_code = newBankCode;
    }
    setBranchCode(newBranchCode:string | null | undefined) {
        this.branch_code = newBranchCode;
    }
    setCountry(newCountry:string | null | undefined) {
        this.country = newCountry;
    }
    setFingerprint(newFingerprint:string | null | undefined) {
        this.fingerprint = newFingerprint;
    }
    setLast4(newLast4:string | null | undefined) {
        this.last4 = newLast4;
    }
    setGeneratedFrom(newGeneratedFrom:GeneratedFrom | null | undefined) {
        this.generated_from = newGeneratedFrom;
    }

    getBankCode() {
        return this.bank_code;
    }
    getBranchCode() {
        return this.branch_code;
    }
    getCountry() {
        return this.country;
    }
    getFingerprint() {
        return this.fingerprint;
    }
    getLast4() {
        return this.last4;
    }
    getGeneratedFrom() {
        return this.generated_from;
    }
}

export class Sofort {
    private country: string | null | undefined;

    constructor(country: string | null | undefined) {
        this.setCountry(country);
    }

    static fromJson(json:any) {
        return new Sofort(json.country);
    }

    setCountry(newCountry:string | null | undefined) {
        this.country = newCountry;
    }

    getCountry() {
        return this.country;
    }
}

export class UsBankAccount {
    private account_holder_type: string | null | undefined;
    private account_type: string | null | undefined;
    private bank_name: string | null | undefined;
    private financial_connectinons_account: string | null | undefined;
    private fingerprint: string | null | undefined;
    private last4: string | null | undefined;
    private networks: Network | null | undefined;
    private routing_number: string | null | undefined;
    private status_details: StatusDetails | null | undefined;

    constructor(account_holder_type: string | null | undefined, account_type: string | null | undefined, bank_name: string | null | undefined, financial_connectinons_account: string | null | undefined, fingerprint: string | null | undefined, last4: string | null | undefined, networks: Network | null | undefined, routing_number: string | null | undefined, status_details: StatusDetails | null | undefined) {
        this.setAccountHolderType(account_holder_type);
        this.setAccountType(account_type);
        this.setBankName(bank_name);
        this.setFinancialConnectionsAccount(financial_connectinons_account);
        this.setFingerprint(fingerprint);
        this.setLast4(last4);
        this.setNetworks(networks);
        this.setRoutingNumber(routing_number);
        this.setStatusDetails(status_details);
    }

    static fromJson(json:any) {
        return new UsBankAccount(json.account_holder_type, json.account_type, json.bank_name, json.financial_connectinons_account, json.fingerprint, json.last4, json.networks !== null && json.networks !== undefined ? Network.fromJson(json.networks) : null, json.routing_number, json.status_details !== null && json.status_details !== undefined ? StatusDetails.fromJson(json.status_details) : null);
    }

    setAccountHolderType(newAccountHolderType:string | null | undefined) {
        this.account_holder_type = newAccountHolderType;
    }
    setAccountType(newAccountType:string | null | undefined) {
        this.account_type = newAccountType;
    }
    setBankName(newBankName:string | null | undefined) {
        this.bank_name = newBankName;
    }
    setFinancialConnectionsAccount(newFinancialConnectionsAccount:string | null | undefined) {
        this.financial_connectinons_account = newFinancialConnectionsAccount;
    }
    setFingerprint(newFingerprint:string | null | undefined) {
        this.fingerprint = newFingerprint;
    }
    setLast4(newLast4:string | null | undefined) {
        this.last4 = newLast4;
    }
    setNetworks(newNetworks:Network | null | undefined) {
        this.networks = newNetworks;
    }
    setRoutingNumber(newRoutingNumber:string | null | undefined) {
        this.routing_number = newRoutingNumber;
    }
    setStatusDetails(newStatusDetails:StatusDetails | null | undefined) {
        this.status_details = newStatusDetails;
    }

    getAccountHolderType() {
        return this.account_holder_type;
    }
    getAccountType() {
        return this.account_type;
    }
    getBankName() {
        return this.bank_name;
    }
    getFinancialConnectionsAccount() {
        return this.financial_connectinons_account;
    }
    getFingerprint() {
        return this.fingerprint;
    }
    getLast4() {
        return this.last4;
    }
    getNetworks() {
        return this.networks;
    }
    getRoutingNumber() {
        return this.routing_number;
    }
    getStatusDetails() {
        return this.status_details;
    }
}

export class StatusDetails {
    private blocked: Blocked | null | undefined;

    constructor(blocked: Blocked | null | undefined) {
        this.setBlocked(blocked);
    }

    static fromJson(json:any) {
        return new StatusDetails(json.blocked !== null && json.blocked !== undefined ? Blocked.fromJson(json.blocked) : null);
    }

    setBlocked(newBlocked:Blocked | null | undefined) {
        this.blocked = newBlocked;
    }

    getBlocked() {
        return this.blocked;
    }
}

export class Blocked {
    private nwtwork_code: string | null | undefined;
    private reason: string | null | undefined;

    constructor(nwtwork_code: string | null | undefined, reason: string | null | undefined) {
        this.setNwtworkCode(nwtwork_code);
        this.setReason(reason);
    }

    static fromJson(json:any) {
        return new Blocked(json.nwtwork_code, json.reason);
    }

    setNwtworkCode(newNwtworkCode:string | null | undefined) {
        this.nwtwork_code = newNwtworkCode;
    }
    setReason(newReason:string | null | undefined) {
        this.reason = newReason;
    }

    getNwtworkCode() {
        return this.nwtwork_code;
    }
    getReason() {
        return this.reason;
    }
}

export class P24 {
    private bank: string | null | undefined;

    constructor(bank: string | null | undefined) {
        this.setBank(bank);
    }

    static fromJson(json:any) {
        return new P24(json.bank);
    }

    setBank(newBank:string | null | undefined) {
        this.bank = newBank;
    }

    getBank() {
        return this.bank;
    }
}

export class PaymentMethodConfigurationDetails {
    private id: string;
    private parent: string | null | undefined;

    constructor(id: string, parent: string | null | undefined) {
        this.setId(id);
        this.setParent(parent);
    }

    static fromJson(json:any) {
        return new PaymentMethodConfigurationDetails(json.id, json.parent);
    }

    setId(newId:string) {
        this.id = newId;
    }
    setParent(newParent:string | null | undefined) {
        this.parent = newParent;
    }

    getId() {
        return this.id;
    }
    getParent() {
        return this.parent;
    }
}